import { defineKey as T } from 'ha/i18n';

export const MaxFileSizeMBHumanized = 7;
export const MaxFileSizeMB = MaxFileSizeMBHumanized * 1024 * 1024; // 7MB

export const TOO_LARGE_FILE_ERROR = T(
  'The file size is too big. The maximum size is %s MB.',
  MaxFileSizeMBHumanized,
);
